import { isReactElement } from "@/app/(site)/_utils/misc/react"
import React from "react"

export type TextSize = "extrasmall" | "small" | "medium" | "large" | "xl"

export type TextProps = {
    weight: "light" | "regular"
    size: TextSize
    strikethrough?: boolean
    children: React.ReactNode
    asChild?: boolean
} & React.HTMLAttributes<HTMLParagraphElement>

const Text: React.FC<TextProps> = ({
    weight,
    size,
    strikethrough,
    children,
    className,
    asChild,
    ...props
}) => {
    const baseClasses = "font-trimRegularNew uppercase"

    const sizeClassesMap = {
        extrasmall: "text-12 leading-120",
        small: "text-14 leading-120 ",
        medium: "text-16 leading-160",
        large: "text-20 leading-200",
        xl: "text-48"
    }
    const weightClasses = {
        light: "font-300",
        regular: "font-400"
    }

    // Define only one letter spacing as it will be the same for 'small' and 'medium' after the breakpoint change
    const letterSpacing = "-tracking-[0.02em]"

    const strikethroughClass = strikethrough ? "line-through" : ""

    const combinedClasses = [
        baseClasses,
        sizeClassesMap[size],
        weightClasses[weight],
        letterSpacing,
        strikethroughClass,
        className
    ]
        .filter(Boolean)
        .join(" ")

    if (asChild && isReactElement(children)) {
        const child = children as React.ReactElement<{ className?: string }>
        return React.cloneElement(child, {
            className: `${child.props.className || ""} ${combinedClasses}`,
            ...props
        })
    }

    return (
        <p className={combinedClasses} {...props}>
            {children}
        </p>
    )
}

export default Text
